import { request, getApiErrorMessage } from '../../helpers';
import { clientService } from '../../services';
import { appActions } from './app.actions';
import { clientBasicTypes } from '../types';

const getClientBasicInfo = (clientId, tenantId) => {
  return dispatch => {
    dispatch(request(clientBasicTypes.GET_CLIENT_BASIC_REQUEST));

    clientService.getClientBasicInfo(clientId, tenantId)
      .then(
        (clientInfo) => {
          if (!clientInfo.enabled) {
            throw { error: 'Client is disabled', code: 'client-disabled' };
          }
          dispatch({
            type: clientBasicTypes.GET_CLIENT_BASIC_SUCCESS,
            payload: clientInfo
          });
        },
        (errorPayload) => {
          const apiMessage = getApiErrorMessage(errorPayload);
          dispatch({
            type: clientBasicTypes.GET_CLIENT_BASIC_FAILURE,
            payload: apiMessage
          });
          dispatch(appActions.apiErrorMessage(apiMessage));
        }
      );
  };
};

export const clientActions = {
  getClientBasicInfo
};